import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const changedetection = defineConnector({
  identifier: "changedetection",
  name: "Changedetection.io",
  tagLine: "Website change detection and monitoring",
  logo,
  protocol: "http",
  tags: ["observability"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) => headerAuth([{ name: "x-api-key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Enter your server URL",
      items: [
        {
          kind: "baseUrl",
          label: "Server URL",
          required: true,
          placeholder: "https://changedetection.example.com",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your changedetection.io instance.",
        },
      ],
    },
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In changedetection.io, go to **Settings → API** and copy your API key.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/api/v1/watch`,
  },
});
